import React from 'react'

import * as FileSaver from 'file-saver'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import ClienteService from '../../../business-api/ClienteService'

import {
    UploadFile,
} from '../../../business-components/UploadFile/UploadFile'

import {
    ButtonBaixarArquivo,
    ButtonVisualizarPDF,
} from '../../../business-components/Button/Button'

import {
    IconButtonExcluirRegistro,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    getArquivoConteudo,
} from '../../arquivo/ArquivoService'

import {
    carregarArquivoHistorico,
    deletarArquivoArquivoAcesso,
} from './AcompanhamentoServiceArquivo'



export const UploadFileUploadArquivos = ({ variaveisGlobais, values, vars, obterArquivoList,
    idTipoSolicitacaoArquivo, tipoSolicitacaoArquivo}) => {

    return (
        <UploadFile
            id={"upload-arquivo-PDF" + (idTipoSolicitacaoArquivo ? "-" + idTipoSolicitacaoArquivo : "")}
            label={LABEL.buttonUploadArquivos}
            accept=".pdf,.xlsx,.jpeg,.png"
            onChange={async (e) => {
                carregarArquivoHistorico(e, variaveisGlobais, values, vars,
                    obterArquivoList, idTipoSolicitacaoArquivo, tipoSolicitacaoArquivo)}
            }
            multiple={true}
            //disabled={processing}
        />
    )
}


export const VisualizarArquivo = ({ variaveisGlobais, arquivoCliente }) => {

    return (
        arquivoCliente?.extensaoArquivo === HARDCODE.PDF
            ?
                <CustomizedDialogsViewPDF
                    maxWidth='xl'
                    popupTitle={arquivoCliente?.nomeArquivo}
                    PopupButton={ButtonVisualizarPDF}
                    carregarPDF={async () => {
                        const arquivoArquivoAcessoDTO =
                            await getArquivoConteudo(variaveisGlobais,
                                ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                                    arquivoCliente?.idArquivo)

                        return arquivoArquivoAcessoDTO.conteudo
                    }}
                    //pdfFile={pdf}
                />
            :
                <ButtonBaixarArquivo
                    onClick={async () => {
                        const arquivoArquivoAcessoDTO =
                            await getArquivoConteudo(variaveisGlobais,
                                ClienteService.obterUsuarioClienteSelecionado(
                                    variaveisGlobais), arquivoCliente?.idArquivo)

                        FileSaver.saveAs(arquivoArquivoAcessoDTO.conteudo,
                            arquivoCliente?.nomeArquivo)
                    }}
                />
    )
}



export const ExclusaoArquivo = ( { variaveisGlobais, values, arquivoCliente, obterArquivoList } ) => {

    return (
        <IconButtonExcluirRegistro
            confirmacaoText={arquivoCliente?.nomeArquivo}
            onClick={() =>
                deletarArquivoArquivoAcesso(arquivoCliente?.idArquivo,
                    variaveisGlobais, values, obterArquivoList)
            }
            //disabled={processing}
        />
    )
}